import { useEffect, useRef, useState } from "react";
import { type Theme, useTheme } from "../contexts/ThemeContext";

const themes: { id: Theme; label: string; icon: string }[] = [
	{ id: "dark", label: "Dark", icon: "\u{1F319}" },
	{ id: "light", label: "Light", icon: "\u{2600}\u{FE0F}" },
	{ id: "midnight", label: "Midnight", icon: "\u{1F30C}" },
	{ id: "forest", label: "Forest", icon: "\u{1F332}" },
];

export function ThemeSwitcher() {
	const { theme, setTheme } = useTheme();
	const [isOpen, setIsOpen] = useState(false);
	const dropdownRef = useRef<HTMLDivElement>(null);

	const currentTheme = themes.find((t) => t.id === theme) || themes[0];

	useEffect(() => {
		function handleClickOutside(event: MouseEvent) {
			if (
				dropdownRef.current &&
				!dropdownRef.current.contains(event.target as Node)
			) {
				setIsOpen(false);
			}
		}

		document.addEventListener("mousedown", handleClickOutside);
		return () => document.removeEventListener("mousedown", handleClickOutside);
	}, []);

	return (
		<div className="theme-switcher" ref={dropdownRef}>
			<button
				className="theme-btn"
				onClick={() => setIsOpen(!isOpen)}
				type="button"
				aria-label="Change theme"
			>
				<span className="theme-icon">{currentTheme.icon}</span>
				<span>{currentTheme.label}</span>
			</button>
			{isOpen && (
				<div className="theme-dropdown">
					{themes.map((t) => (
						<button
							key={t.id}
							type="button"
							className={`theme-option ${theme === t.id ? "active" : ""}`}
							onClick={() => {
								setTheme(t.id);
								setIsOpen(false);
							}}
						>
							<span className="theme-icon">{t.icon}</span>
							<span>{t.label}</span>
						</button>
					))}
				</div>
			)}
		</div>
	);
}
